import JSXComponent from "../../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../../dist/jsx-render/dom";
import { WidgetController } from "../../WidgetController";
import { DynPopup } from "../../../../Components/DynPopup";
import { WidgetTypes } from "../../Widgets/WidgetTypes";
import { app } from "../../../../Frame/App";
import { IWidgetContext } from "./AvailableWidgets/IWidgetContext";
import { IWidgetSettings } from "./AvailableWidgets/IWidgetSettings";

export type EditRowComponentProps = {
    editButton?: HTMLElement;
    controller: WidgetController;
    context: IWidgetContext;
    widgetSettings?: IWidgetSettings
}

export class EditRowComponent extends JSXComponent {
    props: EditRowComponentProps;
    dynPopup: HTMLElement;

    constructor(props: EditRowComponentProps) {
        super(props);
    }

    element: HTMLElement =
        <div className="edit-row">
            {this.renderButtonCancel()}
            {this.renderButtonSave()}
            {this.renderButtonAdd()}
        </div>;

    renderButtonCancel(): HTMLElement {
        let button = <button type="button" class="btn Button-Cancel-MSO mr-1"><i class="far fa-redo-alt mr-2"></i>{Resources['WidgetClient'].cancel}</button>;
        button.addEventListener("click", () => {
            if (this.props.editButton) {
                this.props.editButton.classList.remove("d-none");
            }
            this.props.controller.cancel();
        });
        return button;
    }

    renderButtonSave(): HTMLElement {
        let button = <button type="button" class="btn Button-Save-MSO mr-3"><i class="far fa-save mr-2"></i>{Resources['WidgetClient'].save}</button>;
        button.addEventListener("click", () => {
            if (this.props.editButton) {
                this.props.editButton.classList.remove("d-none");
            }
            this.props.controller.save();
        });
        return button;
    }

    renderButtonAdd(): HTMLElement {
        let button = <button type="button" class="btn Button-Blue-MSO"><i class="far fa-plus mr-2"></i>{Resources['WidgetClient'].add}</button>;
        button.addEventListener("click", () => {
            this.dynPopup = 
                <DynPopup size="widgetdialog" showCancelButton={true}
                    title={Resources['WidgetClient'].add}>
                    <div className="widget-add-container">
                        {...this.renderWidgets()}
                    </div>
                </DynPopup>
            document.body.appendChild(this.dynPopup);
        });
        return button;
    }

    renderWidgets(): HTMLElement[] {
        return this.props.context.renderWidgets(this);
    }

    renderSingleWidget(title: string, type: WidgetTypes, icon: string): HTMLElement {
        let box: HTMLElement = <div className="add-box" data-widget-type={type} draggable={"true"}><div className="title">{title}</div><div className="add-icon"><i className={"far fa-" + icon}></i></div></div>;
        box.addEventListener("dragstart", (ev: DragEvent) => {
            this.props.controller.dragdrop.startDragOnNewWidget(ev);
            setTimeout(() => {
                app.destroyDomElements(this.dynPopup);
            });
        });
        return box;
    }

    render(): HTMLElement {
        return this.element;
    }
}